import React, {Component, Fragment} from 'react';

class Alert extends Component {
  render() {
    const {closeAlert, someActionDo, alertText, btnSomeActionDoText} = this.props;

    return (
      <Fragment>
        <div className="overflow-popup" onClick={closeAlert}></div>
        <div className="alert-common">
          <h6 className="alert-common__subtitle">Warnen</h6>
          <h4 className="alert-common__title">{alertText}</h4>
          <div className="alert-common__btns">
            <button className="alert-common__btn alert-common__btn--cancel" onClick={closeAlert}>nein</button>
            <button className="alert-common__btn alert-common__btn--delete" onClick={someActionDo}>{btnSomeActionDoText}</button>
          </div>
        </div>
      </Fragment>
    );
  }
}

export default Alert;


// WEBPACK FOOTER //
// ./src/components/Alerts/Alert.js